export const MODULE_PATH = "owners";

export const OWNERS = `/s/${MODULE_PATH}/list`;
export const OWNERS_INDEX = `/s/${MODULE_PATH}/`;
export const OWNERS_HOME = `/s/${MODULE_PATH}/home`;
export const OWNERS_DETAIL = `/s/${MODULE_PATH}/detail`;

export const BRANCH_LIST = `/s/${MODULE_PATH}/branch/list`;
export const BRANCH_FORM = `/s/${MODULE_PATH}/branch/form`;
export const BRANCH_DETAIL = `/s/${MODULE_PATH}/branch/detail`;

export const PARKING_LIST = `/s/${MODULE_PATH}/parking/list`;
export const PARKING_FORM = `/s/${MODULE_PATH}/parking/form`;
export const PARKING_DETAIL = `/s/${MODULE_PATH}/parking/detail`;

export const RATE = `/s/${MODULE_PATH}/rates`;
export const RATE_TYPES = `/s/${MODULE_PATH}/rates/types`;
export const RATE_FORM = `/s/${MODULE_PATH}/rates/form`;
export const RATE_DETAIL = `/s/${MODULE_PATH}/rates/detail`;

export const VEHICLES_DETAIL = `/s/vehicles/vehicles/detail`;

export const ZONES = `/s/${MODULE_PATH}/zones`;
export const ZONES_CREATE = `/s/${MODULE_PATH}/zones/create`;
export const ZONES_SHOW = `/s/${MODULE_PATH}/zones/show`;

export const PROMOTIONS = `/s/${MODULE_PATH}/promotions`;
export const PROMOTIONS_DETAIL = `/s/${MODULE_PATH}/promotions/detail`;
export const PROMOTIONS_FORM = `/s/${MODULE_PATH}/promotions/form`;

export const CORPORATE_NETWORKS = `/s/${MODULE_PATH}/corporateNetwork`;
export const CORPORATE_NETWORKS_FORM = `/s/${MODULE_PATH}/corporateNetwork/form`;
export const CORPORATE_NETWORKS_DETAIL = `/s/${MODULE_PATH}/corporateNetwork/detail`;

export const SUPPORT_PHONE_NUMBERS = `/s/${MODULE_PATH}/supportPhoneNumbers`;
export const SUPPORT_PHONE_NUMBERS_FORM = `/s/${MODULE_PATH}/supportPhoneNumbers/form`;
export const SUPPORT_PHONE_NUMBERS_DETAIL = `/s/${MODULE_PATH}/supportPhoneNumbers/detail`;

export const BILLING = `/s/${MODULE_PATH}/billing`;
export const BILLING_PERIOD = `/s/${MODULE_PATH}/billing/period`;
export const BILLING_OWNERS = `/s/${MODULE_PATH}/billing/owners`;
export const BILLING_OWNER = `/s/${MODULE_PATH}/billing/owner`;
export const BILLING_VEHICLE_YEAR = `/s/${MODULE_PATH}/billing/vehicle/year`;
export const BILLING_VEHICLE_MONTH = `/s/${MODULE_PATH}/billing/vehicle/month`;
export const BILLING_VEHICLE_DAY = `/s/${MODULE_PATH}/billing/vehicle/day`;
export const BILLING_ACCOUNTING = `/s/${MODULE_PATH}/billing/accounting`;

export const PAYMENTS = `/s/${MODULE_PATH}/charges`;
export const PAYMENTS_PENDING = `${PAYMENTS}/pending`;
export const PAYMENTS_FINISHED = `${PAYMENTS}/finished`;
export const PAYMENTS_ALL = `${PAYMENTS}/all`;

export const REPORTS = `/s/${MODULE_PATH}/reports`;

export const AGENCY_LIST = `/s/${MODULE_PATH}/agency/list`;
export const AGENCY_FORM = `/s/${MODULE_PATH}/agency/form`;
export const AGENCY_DETAIL = `/s/${MODULE_PATH}/agency/detail`;

export const COLLECTION_LIST = `/s/${MODULE_PATH}/collection/list`;
